// src/polaris-components/RequirePasswordChange.tsx
import { Navigate, Outlet, useLocation, useOutletContext } from 'react-router-dom';

function resolvePasswordChangePath(): string {
    const role = (localStorage.getItem('userRole') || '').toUpperCase();
    if (role === 'ATHLETE') {
        return '/athlete/profile';
    }
    return '/add-admin-profile';
}

function isPasswordChangePath(pathname: string): boolean {
    return pathname === '/add-admin-profile'
        || pathname === '/admin-profile'
        || pathname === '/athlete/profile'
        || pathname.startsWith('/athlete/profile/');
}

/**
 * Guard that ensures users who reset their password via a one-time link
 * must change their password before accessing other parts of the app.
 */
export default function RequirePasswordChange() {
    const location = useLocation();
    const parentContext = useOutletContext();
    const requirePasswordChange = localStorage.getItem('requirePasswordChange') === 'true';

    if (requirePasswordChange && !isPasswordChangePath(location.pathname)) {
        return (
            <Navigate
                to={resolvePasswordChangePath()}
                state={{ requirePasswordChange: true }}
                replace
            />
        );
    }

    return <Outlet context={parentContext} />;
}
